module.exports = __webpack_public_path__ + "static/media/case-pelesys-2.d1f7bb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-pelesys-2.jpg
// module id = 86
// module chunks = 3